import { lazy } from "react";

const DelinkRequest = lazy(() => import("../Component/DelinkFunctionality/DelinkRequest"));
const DelinkingPendingRequestList = lazy(() => import("../Component/DelinkFunctionality/DelinkingPendingRequestList"));

const delinkRoutes = [
  { path: "/delinking-request", element: <DelinkRequest />, protected: false },
  { path: "/delinking-Pending-request-list", element: <DelinkingPendingRequestList />, protected: false },
];

export default delinkRoutes;
